module.exports = __webpack_public_path__ + "static/media/agent.5811372e.svg";